export default function DSA_Linear_Search_Time() {
  return <div>DSA_Linear_Search_Time Component</div>;
}
